import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import { Reveal, Kicker } from "@/components/site/Reveal";
import { usePageMeta } from "@/lib/seo";

export default function QuizzListPage() {
  usePageMeta("Quiz d'auto-évaluation", "Testez votre maturité agile et vos pratiques d'ingénierie des exigences en quelques minutes avec nos quiz gratuits.");
  const [quizzes, setQuizzes] = useState([]);

  useEffect(() => {
    api.get("/quizzes").then((r) => setQuizzes(r.data)).catch(() => {});
  }, []);

  return (
    <main className="bg-[#0b0f19] min-h-screen" data-testid="quizz-list-page">
      <Nav />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-24">
        <Reveal>
          <Kicker>Auto-évaluation</Kicker>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-50">
            <span className="grad-text">Quiz</span>
          </h1>
          <p className="mt-5 text-slate-400 max-w-xl text-sm sm:text-base leading-relaxed">
            Testez vos pratiques en quelques minutes : chaque quiz vous situe et vous livre des
            recommandations concrètes. De nouveaux quiz sont ajoutés régulièrement.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-5">
          {quizzes.map((q, i) => (
            <Reveal key={q.quiz_id} delay={i * 0.06}>
              <Link
                to={`/quizz/${q.quiz_id}`}
                data-testid={`quiz-card-${q.quiz_id}`}
                className="block border border-teal-400/20 bg-[#10201f] card-lift p-7 h-full"
              >
                <div className="text-[11px] font-mono2 uppercase tracking-[0.2em] text-teal-300">
                  {q.category} · {q.question_count} questions · {q.duration}
                </div>
                <h3 className="mt-3 font-heading text-xl font-semibold text-slate-100">{q.title}</h3>
                <p className="mt-2 text-sm text-slate-500">{q.description}</p>
                <span className="mt-4 inline-block text-sm text-teal-300">Commencer →</span>
              </Link>
            </Reveal>
          ))}
        </div>
        {quizzes.length === 0 && <p className="mt-14 text-sm text-slate-500">Les premiers quiz arrivent bientôt.</p>}
      </div>
      <Footer />
    </main>
  );
}
